export default __webpack_public_path__ + "img/icon-flag-de.asset.75514bde.jpg";